import axios from "axios";

import { successHandling } from "../helpers/successHandling";
import {
  currentDateInUTC,
  scheduledDateInUTC
} from "../helpers/datetimeHandlers";
import { apiSelectedGroupsHandler } from "../helpers/apiSelectedIdsHandler";

export const restartSystemAPI = async (
  device_id,
  devices,
  selectedGroups,
  executeType,
  datetime,
  command,
  t,
  successfulText
) => {
  let formData = new FormData();
  formData.append("device_id", device_id); // single device
  apiSelectedGroupsHandler(formData, devices, selectedGroups); // multiple devices
  formData.append("execute_type", executeType);
  formData.append(
    "execute_datetime",
    datetime === "immediately"
      ? currentDateInUTC()
      : scheduledDateInUTC(datetime)
  );
  formData.append("close_application_command", command);

  await axios({
    url: `/api/v2/command/restart-system-send`,
    method: "POST",
    data: formData
  });
  successHandling(t, successfulText);
  return true;
};
